import { get } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import billingsFormBasic from '@/components/services/billings/form/basic'

function renderBillingsFormBasic(h) {
  return h(
    billingsFormBasic,
    {
      props: {
        value: this.proxy,
        currency: this.currency,
        required: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        itemsDisabled: this.ownerIdsDisabled,
        dense: true,
        required: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}
function renderMultiplier(h) {
  return h(
    'div',
    {
      class: `${Services.billings}-form__multiplier`
    },
    [
      h(
        components['text-field'],
        {
          props: {
            value: this.proxy.data.multiplier,
            label: this.getTranslate(`${Services.billings}.labels.multiplier`),
            dense: true,
            details: false,
            type: 'number',
            min: 1,
            step: 'any',
            clearable: true,
            required: true
          },
          on: {
            input: event => {
              this.proxy.data.multiplier = event
            }
          }
        }
      ),

      h(
        components.switch,
        {
          props: {
            value: this.proxy.data.hidden.noRef,
            label: this.getTranslate(`${Services.billings}.labels.ref.${this.proxy.data.hidden.noRef}`),
            outline: true
          },
          on: {
            input: event => {
              this.proxy.data.hidden.noRef = event
            }
          }
        }
      )
    ]
  )
}
function renderComment(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy.data.hidden.comment,
        label: this.getTranslate(`${Services.billings}.labels.comment`),
        error: get(this.errors, 'data.hidden.comment'),
        dense: true,
        details: false,
        grow: true,
        rows: 3,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.data.hidden.comment = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.billings}-form`
    },
    [
      renderBillingsFormBasic.call(this, h),
      renderSelectorOwner.call(this, h),
      renderMultiplier.call(this, h),
      renderComment.call(this, h)
    ]
  )
}
